const LoaderState = {
    loaders: {}
};

export default LoaderState;